module.exports = __webpack_public_path__ + "static/img/return.45b7d46.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/return.png
// module id = X9tM
// module chunks = 1